module.exports = __webpack_public_path__ + "static/vMore-506d159811b6611af6646d4919b90c9a.png";